module.exports = __webpack_public_path__ + "static/organic-search-row-two-hero-left-cf37891fa2aa33177053f8e9f7a3b128.jpg";